import { render, staticRenderFns } from "./index.vue?vue&type=template&id=30e6b834&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=30e6b834&scoped=scoped&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=30e6b834&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e6b834",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30e6b834')) {
      api.createRecord('30e6b834', component.options)
    } else {
      api.reload('30e6b834', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=30e6b834&scoped=true&", function () {
      api.rerender('30e6b834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trial/discipline/index.vue"
export default component.exports